// El menu del sistema. Vive en su propio archivo porque lo usan dos
// pantallas: el menu lateral (App.js) y el inicio, que muestra las mismas
// opciones distribuidas en columnas.
//
// El menu sigue el proceso de las terapias: primero se parametriza, luego se
// registran las personas, los modelos de intervencion, las terapias con su
// plan y sus periodos, las sesiones que el terapeuta registra y, al final, la
// facturacion con sus pagos.
//
// Cada opcion puede declarar el acceso que la concede. Con la seguridad activa
// solo se ven las opciones cuyo acceso tiene el usuario; sin seguridad, o sin
// accesos cargados, se ve todo (comportamiento permisivo de siempre).
import { Tooltip } from "@mui/material";
import { Inbox as InboxIcon, Person as PersonIcon, RecordVoiceOver as RecordVoiceOverIcon
  , EmojiPeople as EmojiPeopleIcon, CalendarMonth as CalendarMonthIcon
  , AssignmentInd as AssignmentIndIcon, EscalatorWarning as EscalatorWarningIcon
  , ContentPasteSearch as ContentPasteSearchIcon, Badge as BadgeIcon
  , AddCard as AddCardIcon, NoteAlt as NoteAltIcon, Calculate as CalculateIcon
  , BarChart as BarChartIcon, List as ListIcon, Settings as SettingsIcon
  , School as SchoolIcon, Timeline as TimelineIcon, MonitorHeart as MonitorHeartIcon
  , MedicalServices as MedicalServicesIcon, Security as SecurityIcon
  , Inventory as InventoryIcon, AccountBalanceWallet as AccountBalanceWalletIcon } from "@mui/icons-material";
export const navGroups = [
    {
      title: "Inicio",
      path: "/",
      icon:
      <Tooltip title="Inicio" placement="right-end">
        <InboxIcon aria-label="Inicio" />
      </Tooltip>
    },
    {
      title: "Personas",
      icon:
      <Tooltip title="Personas" placement="right-end">
        <PersonIcon aria-label="Personas" />
      </Tooltip>,
      children: [
        {
          title: "Personas",
          path: "/person",
          acceso: "persona.ver",
        },
        {
          title: "Participantes",
          path: "/member",
          acceso: "participante.ver",
        },
      ]
    },
    {
      title: "Personal",
      icon:
      <Tooltip title="Personal" placement="right-end">
        <BadgeIcon aria-label="Personal" />
      </Tooltip>,
      children: [
        {
          title: "Personal",
          path: "/trabajador",
          acceso: "trabajador.ver",
        },
        {
          title: "Cargos",
          path: "/cargo",
          acceso: "trabajador.ver",
        },
        {
          title: "Grupos de Cargo",
          path: "/grupocargo",
          acceso: "trabajador.ver",
        },
      ]
    },
    {
      title: "Atencion",
      icon:
      <Tooltip title="Atencion" placement="right-end">
        <MedicalServicesIcon aria-label="Atencion" />
      </Tooltip>,
      children: [
        {
          title: "Atenciones",
          path: "/atencion",
          acceso: "atencion.ver",
        },
        {
          title: "Diagnosticos",
          path: "/diagnostico",
          acceso: "diagnostico.ver",
        },
        {
          title: "Evaluaciones",
          path: "/evaluacion/0",
          acceso: "evaluacion.ver",
        },
        {
          title: "Temas de Evaluacion",
          path: "/evaluacion/temas",
          acceso: "evaluacion.ver",
        },
        {
          title: "Catalogo de Objetivos",
          path: "/objetivocatalogo",
          acceso: "evaluacion.ver",
        },
        {
          title: "Objetivos de Participantes",
          path: "/participanteobjetivo",
          acceso: "evaluacion.ver",
        },
      ]
    },
    {
      title: "Modelos",
      icon:
      <Tooltip title="Modelos de Terapia" placement="right-end">
        <SchoolIcon aria-label="Modelos de Terapia" />
      </Tooltip>,
      children: [
        {
          title: "Modelos de Terapia",
          path: "/model",
          acceso: "modelo.ver",
        },
      ]
    },
    {
      title: "Terapias",
      icon:
      <Tooltip title="Terapias" placement="right-end">
        <TimelineIcon aria-label="Terapias" />
      </Tooltip>,
      children: [
        {
          title: "Terapias",
          path: "/therapy",
          acceso: "terapia.ver",
        },
        {
          title: "Periodos",
          path: "/period",
          acceso: "periodo.ver",
        },
        {
          title: "Planes de Terapia",
          path: "/therapyplan",
          acceso: "terapiaPlan.ver",
        },
        {
          title: "Mis Planes de Terapia",
          path: "/therapyplanterapist",
          acceso: "terapiaPlanTerapeuta.ver",
        },
        {
          title: "Periodos de Terapias",
          path: "/therapyPeriod",
          acceso: "terapiaPeriodo.ver",
        },
        {
          title: "Pagos de Periodos",
          path: "/therapyperiod/pago",
          acceso: "terapiaPeriodoPago.ver",
        },
        {
          title: "Horarios Disponibles",
          path: "/horario-terapeuta",
          acceso: "sesion.ver",
        },
      ]
    },
    {
      title: "Sesiones",
      icon:
      <Tooltip title="Sesiones" placement="right-end">
        <MonitorHeartIcon aria-label="Sesiones" />
      </Tooltip>,
      children: [
        {
          title: "Sesiones de Terapeuta",
          path: "/session/0",
          acceso: "sesionTerapeuta.ver",
        },
        {
          title: "Mis Sesiones",
          path: "/sesionterapeuta",
          acceso: "sesionTerapeuta.ver",
        },
        {
          title: "Resumen de Tiempos",
          path: "/planilla",
          acceso: "sesion.ver",
        },
        {
          title: "Sesiones",
          path: "/session",
          acceso: "sesion.ver",
        },
      ]
    },
    {
      title: "Facturacion",
      icon:
      <Tooltip title="Facturacion" placement="right-end">
        <ContentPasteSearchIcon aria-label="Facturacion" />
      </Tooltip>,
      children: [
        {
          title: "Comprobantes",
          path: "/receipt",
          acceso: "comprobante.ver",
        },
        {
          title: "Anular Pagos",
          path: "/receipt/pago/anular",
          acceso: "pago.anular",
        },
        {
          title: "Consolidar Pagos",
          path: "/receipt/pago/consolidar",
          acceso: "pago.consolidar",
        },
        {
          title: "Descuentos",
          path: "/therapyperiod/descuentos",
          acceso: "descuento.listar",
        },
      ]
    },
    {
      title: "Inventario",
      icon:
      <Tooltip title="Inventario y Kardex" placement="right-end">
        <InventoryIcon aria-label="Inventario" />
      </Tooltip>,
      children: [
        {
          title: "Artículos y Materiales",
          path: "/inventario/articulos",
          acceso: "articulo.ver",
        },
        {
          title: "Kardex de Movimientos",
          path: "/inventario/kardex",
          acceso: "kardex.ver",
        },
        {
          title: "Reportes de Inventario",
          path: "/inventario/reportes",
          acceso: "kardex.reporte",
        },
      ]
    },
    {
      title: "Caja Chica",
      icon:
      <Tooltip title="Caja Chica" placement="right-end">
        <AccountBalanceWalletIcon aria-label="Caja Chica" />
      </Tooltip>,
      children: [
        {
          title: "Gestión de Caja Chica",
          path: "/cajachica",
          acceso: "cajachica.ver",
        },
        {
          title: "Arqueo y Liquidación",
          path: "/cajachica/reportes",
          acceso: "cajachica.reporte",
        },
      ]
    },
    {
      // Reportes va junto a la configuracion, al final del menu: es una
      // pagina que lista los informes, y se ve si el usuario tiene alguno de
      // sus accesos.
      title: "Reportes",
      path: "/reporte",
      icon:
      <Tooltip title="Reportes" placement="right-end">
        <BarChartIcon aria-label="Reportes" />
      </Tooltip>,
      acceso: ["modeloReporte.ver", "terapiaReporte.ver", "sesionReporte.ver", "terapiaPlanReporte.ver"],
    },
    {
      title: "Configuracion",
      icon:
      <Tooltip title="Configuracion" placement="right-end">
        <SettingsIcon aria-label="Configuracion" />
      </Tooltip>,
      children: [
        {
          title: "Filiales",
          path: "/filial",
          acceso: "filial.ver",
        },
        {
          title: "Salones",
          path: "/salon",
          acceso: "salon.ver",
        },
        {
          title: "Direcciones",
          path: "/direccion",
          acceso: "direccion.ver",
        },
        {
          title: "Ubigeo",
          path: "/ubigeo",
          acceso: "ubigeo.ver",
        },
        {
          title: "Catalogos",
          path: "/catalog",
          acceso: "catalogo.ver",
        },
        {
          title: "Dias Feriados",
          path: "/diaferiado",
          acceso: "diaFeriado.ver",
        },
        {
          title: "Conceptos de Cobro",
          path: "/invoiceItem",
          acceso: "conceptoCobro.ver",
        },
        {
          title: "Descuentos Catálogo",
          path: "/descuentocatalogo",
          acceso: "descuento.listar",
        },
        {
          title: "Puntuacion",
          path: "/puntuacion",
          acceso: "puntuacion.ver",
        },
        {
          // Los parametros del sistema: ahi se enciende y apaga la bitacora
          // de cambios (BITACORA_ACTIVA).
          title: "Parametros",
          path: "/configuracion",
          acceso: "configuracion.ver",
        },
      ]
    },
    {
      title: "Seguridad",
      icon:
      <Tooltip title="Seguridad" placement="right-end">
        <SecurityIcon aria-label="Seguridad" />
      </Tooltip>,
      children: [
        {
          // Lo que decide es el acceso, no la cuenta: el Director tiene los
          // accesos de usuarios, roles y accesos, asi que los ve. El
          // mantenimiento de usuarios (crear cuentas y cambiar roles) es del
          // ADMIN, y eso lo exige la API.
          title: "Usuarios",
          path: "/security/user",
          acceso: "usuario.ver",
        },
        {
          title: "Roles",
          path: "/security/role",
          acceso: "rol.ver",
        },
        {
          title: "Accesos",
          path: "/security/access",
          acceso: "seguridad.usuario",
        },
        {
          title: "Autorizaciones",
          path: "/authorization",
          acceso: "autorizacion.ver",
        },
        {
          // La bitacora de cambios: de solo lectura, solo para ver que registro
          // cada quien. Va en el grupo de Seguridad porque es de control.
          title: "Trazabilidad de Operaciones",
          path: "/bitacora/operaciones",
          acceso: "bitacora.ver",
        },
        {
          title: "Bitacora de Cambios",
          path: "/bitacora",
          acceso: "bitacora.ver",
        },
        {
          // Dashboard de monitoreo: combina las bitacoras de cambios, login y
          // errores. Solo admin y rol monitoreo.
          title: "Dashboard de Monitoreo",
          path: "/monitoreo",
          acceso: "monitoreo",
        },
        {
          // Bitacora de ejecucion de reportes (estandar SSIS/SSRS ExecutionLog):
          // Control centralizado para roles Director, Administrador y Monitoreo.
          title: "Bitacora de Reportes",
          path: "/seguridad/bitacora-reportes",
          acceso: "bitacorareporte.ver",
        },
      ]
    },
  ]
// Las opciones que el usuario puede ver. Un grupo se ve si queda algo visible
// dentro, asi que se filtra hacia abajo.
//
// Una opcion puede declarar un acceso o una lista de ellos: con la lista basta
// tener uno (los reportes, que se listan juntos en su pagina).
//
// Las opciones marcadas soloAdmin solo las ve el usuario admin: son las de
// administracion de la seguridad (usuarios, roles y accesos) y no dependen de
// la seguridad activa ni de los accesos cargados.
export const visiblesDe = (items, accesos, seguridadActiva, usuario) => (items || [])
  .map((item) => {
    if (!item.children) return item;

    const visibles = visiblesDe(item.children, accesos, seguridadActiva, usuario);

    return visibles.length > 0 ? { ...item, children: visibles } : null;
  })
  .filter((item) => {
    if (item === null) return false;

    // Compara sin importar mayusculas: el codigo de la cuenta se guarda en
    // mayusculas ("ADMIN").
    if (item.soloAdmin && (usuario || "").toLowerCase() !== "admin") return false;

    if (item.acceso) {
      if (seguridadActiva === "S") {
        const requeridos = Array.isArray(item.acceso) ? item.acceso : [item.acceso];

        return requeridos.some((acceso) => (accesos || []).includes(acceso));
      }
    }

    return true;
  });